"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Use this function as a shortcut to easily access the data from a firestore snapshot, since it handles checking if it exists for you.
 * @param snapshot A snapshot returned from a firestore query.
 * @returns The data contained within the snapshot. Throws an error if the snapshot is empty, or the snapshot doesn't exist.
 */
function getDocumentData(snapshot) {
    if (snapshot.exists) {
        var data = snapshot.data();
        if (data) {
            return Promise.resolve(data);
        }
        else {
            return Promise.reject(new Error("Snapshot data does not exist"));
        }
    }
    else {
        return Promise.reject(new Error("Snapshot does not exist"));
    }
}
exports.default = getDocumentData;
//# sourceMappingURL=get-document-data.js.map